import type { ReactNode } from 'react';

import type { BackgroundColor } from '../../constants';
import type { MotifScheme } from '../../motif';
import type { BaseComponentProps } from '../../types';

export interface FooterV2Props extends BaseComponentProps {
  motifScheme?: MotifScheme;
  /** @deprecated Use motifScheme instead. */
  backgroundColor?: BackgroundColor;
  children?: ReactNode;
  hideFooterLinks?: boolean;
}
